module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/march-9a34eb615b5fa2dffc6438791e90da2f.png";